import * as React from 'react';
import * as styles from './Heading.css';
import { UIHeading1, UIHeading5 } from '@cian/ui-kit';

interface IHeadingProps {
  title: string;
  price?: string;
}

export const Heading: React.FC<IHeadingProps> = ({ title, price }) => {
  return (
    <div className={styles['heading']}>
      <UIHeading5>{title}</UIHeading5>
      {price && <UIHeading1 as="h1">{price}</UIHeading1>}
    </div>
  );
};
